import { useState, useEffect } from 'react';

const usePermissions = () => {
    const [permissions, setPermissions] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        try {
            const storedPermissions = localStorage.getItem('userPermissions');
            if (storedPermissions) {
                setPermissions(JSON.parse(storedPermissions));
            }
        } catch (error) {
            console.error('Error loading permissions:', error);
        } finally {
            setLoading(false);
        }
    }, []);

    const hasPermission = (category, permission) => {
        return permissions[category]?.[permission] === true;
    };

    // ✅ دالة للتحقق من صلاحية إحصائية معينة
    const hasStatPermission = (statName) => {
        return hasPermission('إحصائيات المتابعة الدورية', statName);
    };

    return { 
        hasPermission, 
        hasStatPermission,  // ✅ جديد
        loading,
        permissions 
    };
};

export default usePermissions;